const WORDS = ["Steel Coils", "20 / 40 FT Containers", "Cement", "Coal", "ODC Machinery", "Project Cargo"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="font-display text-5xl sm:text-7xl font-black uppercase tracking-tight text-outline px-6">
          {w}
        </span>
        <span className="w-3 h-3 bg-amber-500 mx-2" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-slate-800 py-10 select-none"
    aria-hidden="true"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
